<section
    class=" content2-bg-image no-padding cover-background xs-bg-none border-none bg-img-ten header-margin-top-medium"
    id="" data-img-size="(W)1920px X (H)590px"
    style="background: linear-gradient(rgba(0, 0, 0, 0.00784314), rgba(0, 0, 0, 0.00784314)), url('assets/images/bg-image/bg-home-empresa.jpg') fixed;">
    <div class="container sm-width-100 sm-no-padding">
        <div
            class="bg-cream  width-80 sm-width-60 xs-width-100 content-style1 padding-four md-padding-eight sm-padding-eighteen">
            <!-- section title -->
            <h2 *ngIf="!incrustado"
                class="title alt-font title-extra-large-2 sm-title-extra-large-2 xs-section-title-large text-brown margin-one-bottom">
                Contáctenos</h2>
            <h2 *ngIf="incrustado && nombre"
                class="title alt-font title-extra-large-2 sm-title-extra-large-2 xs-section-title-large text-brown margin-one-bottom">
                Obtenga más información acerca de {{nombre}}</h2>
            <!-- end section title -->
            <div class="text-medium sm-text-medium text-dark-gray margin-fifteen-bottom">
                <p> Póngase en contacto con nosotros y en breve nos comunicaremos con usted.</p>
            </div>
            <form [formGroup]="contactoForm" class="form-signin" (ngSubmit)="onSubmit()">
                <div class="formGroup">
                    <div *ngIf="submitted && f.name.errors" class="invalid-feedback">
                        <div *ngIf="f.name.errors.required">Nombre es requerido</div>
                    </div>
                    <input type="text" formControlName="name" name="name" data-email="required" id="name"
                        placeholder="* Nombre" class="medium-input border-radius-8"
                        [ngClass]="{ 'is-invalid': submitted && f.name.errors }">
                </div>
                <div class="formGroup">
                    <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                        <div *ngIf="f.email.errors.required">Email es requerido</div>
                    </div>
                    <input type="text" formControlName="email" name="email" data-email="required" id="email"
                        placeholder="* Email" class="medium-input border-radius-8"
                        [ngClass]="{ 'is-invalid': submitted && f.email.errors }">
                </div>
                <div class="formGroup">
                    <div *ngIf="submitted && f.phone.errors" class="invalid-feedback">
                        <div *ngIf="f.phone.errors.required">Teléfono es requerido</div>
                    </div>
                    <input type="text" formControlName="phone" name="phone" data-email="required" id="phone"
                        placeholder="* Teléfono" class="medium-input border-radius-8"
                        [ngClass]="{ 'is-invalid': submitted && f.phone.errors }">
                </div>
                <div class="formGroup">
                    <textarea name="comment" formControlName="comment" id="comment"
                        placeholder="Escriba su consulta aquí..." class="medium-input border-radius-8"></textarea>
                </div>
                <div class="formGroup">
                    <botdetect-captcha styleName="ExampleCaptcha"></botdetect-captcha>
                    <label>
                        <span>Escriba las letras de la imagen de arriba:</span>
                        <input type="text" id="captchaCode" name="captchaCode" formControlName="captchaCode">
                    </label>
                </div>
                <div class="form-group">
                    <button class="btn-medium btn-circle btn bg-dark-brown text-white">ENVIAR MENSAJE</button>
                    <img *ngIf="loading"
                        src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                </div>
                <alert *ngIf="alerta!=''" type="danger" [dismissible]="true" (onClosed)="onClosed(alert)">{{ alerta }}
                </alert>
            </form>
        </div>
    </div>
</section>